import { PostHogEvents } from './PostHogEvents';

export const PostHogMessages = {
  [PostHogEvents.USER_SIGNED_UP]: 'User completed registration.',
  [PostHogEvents.User_SIGNUP_FAILED]: 'User registration failed.',
  [PostHogEvents.USER_LOGGED_IN]: 'User successfully logged in.',
  [PostHogEvents.User_LOGIN_FAILED]: 'User login failed.',
  [PostHogEvents.FORM_SUBMITTED]: 'Plaintiff Factsheet form submitted.',
  [PostHogEvents.USER_LOGGED_OUT]: 'User logged out.',
  [PostHogEvents.USER_FORGOT_PASSWORD]: 'User clicked "Forgot Password".',
  [PostHogEvents.FORGET_PASSWORD_INVALID_EMAIL]:
    'User entered an invalid email for password reset.',
  [PostHogEvents.FORGET_PASSWORD_REQUESTED]: 'Password reset request submitted.',
  [PostHogEvents.FORGET_PASSWORD_FAILED]: 'Password reset request failed.',
  [PostHogEvents.PASSWORD_RESET_SUCCESS]: 'User successfully reset password.',
  [PostHogEvents.FORM_SECTION_VIEWED]: 'User viewed a form section.',
  [PostHogEvents.FORM_FIELD_FOCUSED]: 'User focused on a form field.',
  [PostHogEvents.FORM_PROGRESS_SAVED]: 'Form progress was successfully saved.',
  [PostHogEvents.PAGE_VIEWED]: 'User viewed a page.',
  [PostHogEvents.POPUP_OPEN]: 'Popup modal opened.',
  [PostHogEvents.FORM_PROGRESS_SAVED_FAILED]: 'Failed to save form progress.',
  [PostHogEvents.DISCARD_CHANGES_POPUP]: 'Discard changes popup shown.',
  [PostHogEvents.VERIFICATION_EMAIL_SENT]: 'Verification email sent to user.',
  [PostHogEvents.EMAIL_VERIFIED]: 'User verified email success',
};
